module.exports = __webpack_public_path__ + "cc5eb2184758d79e75d41e7bfcc5a519.png";


//////////////////
// WEBPACK FOOTER
// ./app/stylesheets/tablet-preview/images/bg.png
// module id = 1103
// module chunks = 4